import { Dialog } from 'primereact/dialog';
import './Dialog.component.scss';

export default Dialog;
